import { createContext, useContext, useLayoutEffect, type ReactNode } from "react";
import { ConfigProvider, type ThemeConfig } from "./ui/antd";
import { adminIceTheme } from "./admin-appearance";
import "./home-service.css";

const HomeServiceVisualContext = createContext(false);
export const useHomeServiceVisual = () => useContext(HomeServiceVisualContext);

/** Visual tokens for the home-service workspace; public and agency pages keep their own theme. */
const homeServiceTheme: ThemeConfig = {
  token: { borderRadiusLG: 12, controlHeight: 36 },
  components: {
    Button: {
      colorPrimary: adminIceTheme.token!.colorPrimary,
      colorPrimaryHover: adminIceTheme.token!.colorPrimaryHover,
      colorPrimaryActive: adminIceTheme.token!.colorPrimaryActive,
      primaryColor: "#ffffff",
    },
    Segmented: { itemSelectedBg: "#e6efec", itemSelectedColor: adminIceTheme.token!.colorPrimaryText },
    Table: { headerBg: "#f6f8fa", headerColor: adminIceTheme.token!.colorTextSecondary, rowHoverBg: "#f6f8fa" },
  },
};

export default function HomeServiceAppearance({ enabled, children }: { enabled: boolean; children: ReactNode }) {
  useLayoutEffect(() => {
    if (!enabled) return;
    document.body.classList.add("home-service-overlays");
    return () => document.body.classList.remove("home-service-overlays");
  }, [enabled]);
  return enabled ? <HomeServiceVisualContext.Provider value><ConfigProvider theme={homeServiceTheme}><div className="home-service-surface">{children}</div></ConfigProvider></HomeServiceVisualContext.Provider> : children;
}
